module.exports = __webpack_public_path__ + "static/media/logout-white.3fd120e6.svg";